import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './HeaderLayout.scss';
import SvgX from '../svg/X.js';

var HeaderLayout = function HeaderLayout(_ref) {
  var title = _ref.title,
      onCancel = _ref.onCancel,
      theme = _ref.theme,
      closeButton = _ref.closeButton;


  return React.createElement(
    'div',
    { className: classNames(styles.header, styles[theme]), 'data-hook': 'header-layout' },
    React.createElement(
      'span',
      { className: styles.titleLabel, 'data-hook': 'header-layout-title' },
      title
    ),
    closeButton && React.createElement(
      'button',
      { className: styles.close, 'data-hook': 'header-close-button', onClick: onCancel },
      React.createElement(SvgX, { width: 9, height: 9, thickness: 1, color: 'white' })
    )
  );
};

HeaderLayout.defaultProps = {
  theme: 'blue',
  closeButton: true
};

HeaderLayout.propTypes = {
  title: PropTypes.node,
  onCancel: PropTypes.func,
  closeButton: PropTypes.bool,
  theme: PropTypes.oneOf(['red', 'green', 'blue', 'lightGreen'])
};

export default HeaderLayout;
//# sourceMappingURL=HeaderLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MessageBox/HeaderLayout.js